export const styles = () => ({
  boxSizing: 'border-box',

  '&.MuiGrid-container': {
    display: 'flex !important',
    width: 'auto !important',
    flexWrap: 'wrap',
    marginTop: '-15px !important',
    marginLeft: '-15px !important',

    '& > .MuiGrid-item': {
      paddingTop: '15px !important',
      paddingLeft: '15px !important',
    },
  },
});
